<template>
  <div class="chatGptList">
    <div class="chatGptList-header">
      <div class="row align-items-center">
        <div class="col-12 col-md-3 text-center text-md-left">
          <img
            class="logo"
            style="max-height: 100px"
            alt="logo"
            src="spendid-logo.png"
          />
          <!-- <img
            class="logo-w"
            style="max-height: 100px"
            alt="logo"
            src="spendid-logo.png"
          /> -->
          <!-- <img alt="logo" src="CentSai-Logo.svg" class="centi-logo" /> -->
        </div>
        <div class="col-12 col-md-6">
          <div class="get-advice-articles-head text-center">
            <!-- <h6 class="m-0 mb-2">Dealing With The Cost of</h6> -->
            <!-- <h6 class="m-0">How to Lower Expenses For</h6> -->
            <h4 class="font-weight-bold" v-if="!message.largePrompt">{{ message.title }}</h4>
            <h4 class="font-weight-bold" v-if="message.largePrompt">Budget Health Analysis</h4>
            <button
              class="btn mt-2 btn-theme btn-sm download_as_pdf"
              v-if="!loader && !message.largePrompt"
              @click="dowloadReport(true)"
            >
              Download as PDF
            </button>
            <!-- <button
            class="btn mt-2 btn-green btn-sm ml-2"
            v-if="!loader"
            @click="sendAsEmail = true"
          >
            Email as PDF
          </button> -->
          </div>
          <!-- <div
          v-if="sendAsEmail"
          class="mt-2 text-center"
          style="display: flex; justify-content: center; align-items: center"
        >
          <input
            type="email"
            v-model="email"
            style="max-width: 200px"
            placeholder="Your e-mail"
            class="form-control"
          />
          <button
            style="border-radius: 100px !important"
            class="btn ml-2 btn-green btn-sm"
            @click="dowloadReport(false)"
            :disabled="!/^[^\s@]+@[^\s@]+\.[^\s@]+$/.test(email)"
          >
            Send
          </button>
        </div> -->
        </div>
        <div class="col-12 col-md-3 text-center">
          <!-- <img class="nw-logo" width="150" alt="logo" src="nw_logo_spend.png" /> -->
        </div>
      </div>
    </div>
    <div class="chatGptList-disclaimer">
      <b-row class="justify-content-center">
        <b-col md="12" lg="6">
          <p class="disclaimer-ai-text">
            "The ideas provided here are for informational purposes 
            only and do not constitute professional financial advice." 
          </p>
        </b-col>
      </b-row>
    </div>
    <!-- <div class="col-12 col-lg-4" v-for="(chatGpt, index1) in chatGptList" :key="index1">


            <ChatGptData
                :mainTitle="chatGpt.tittles"
                :url="chatGpt.url"
                v-on:gptValue="gptValue"
                :image="chatGpt.image"
            />
      </div> -->
    <b-row>
      <b-col v-if="!loader">
        <div class="chatgpt-info" v-if="!message.largePrompt">
          <div
            class="message-ai-list"
            v-for="(message, i) in messageAI"
            :key="i"
          >
          <div class="response-info-text">
            <h3>{{ message.title }}</h3>
            <ul>
              <li v-for="(result, k) in message.results" :key="k">
                {{ result }}
              </li>
            </ul>
          </div>
          </div>
        </div>
        <div  class="chatgpt-info"  v-else>
          <div
            class="message-ai-list"
            v-for="(message, i) in messageAI"
            :key="i"
          >
           <div class="response-info-text">
            <h3>{{ message.title }}</h3>
            <p>{{ message.description }}</p>
            <ul>
              <li v-for="(result, k) in message.list" :key="k">
                {{ result }}
              </li>
            </ul>
           </div>
            <div class="response-image">
              <img v-if="message.imageUrl" :alt="`${message.title} logo`" :src="message.imageUrl" class="centi-logo" />
            </div>
          </div>
        </div>

      </b-col>
    </b-row>
    <b-row>
      <b-col>
        <!-- <div class="text-center loading-text p-3" v-if="loader">Loading...</div> -->
        <div
          v-if="loader"
          class="d-flex flex-column align-items-center justify-content-center pt-2"
          style="min-height: 130px"
        >
          <div class="loader-ai"></div>
          <p class="mb-0 mt-2 loading-text">Generating response, almost there...</p>
          <quoteCarousel />
        </div>
      </b-col>
    </b-row>
    <b-row class="mt-3">
      <b-col class="text-center" v-if="!message.largePrompt">
        <b-button
          v-if="loadTimes < 3"
          @click="generateRes()"
          class="btn mt-2 btn-green border-radius px-5"
        >
          More
        </b-button>
        <!-- <button
          v-if="chatGptList.length < total"
          @click="nextPage"
          class="btn mt-2 btn-green btn-sm"
        >
          Load More
        </button> -->
      </b-col>
      <b-col v-else class="text-center" >
        <b-button
          v-if="!loader"
          @click="regenerateRes()"
          class="btn mt-2 btn-green border-radius px-5"
        >
        Regenerate
        </b-button>
        <b-button
          v-if="!loader"
          @click="saveRes()"
          class="btn mt-2 btn-green border-radius px-5 ml-2"
        >
          Download
        </b-button>
      </b-col>
    </b-row>
  </div>
</template>

<script>
import jsPDF from "jspdf";
import "jspdf-autotable";
import moment from "moment-timezone";
// import ChatGptData from "./ChatGptData.vue";
import quoteCarousel from '@/quote/QuoteCarousel'

export default {
  name: "ChatGptList",
  props: ["uses"],
  components: {
    // ChatGptData,
    quoteCarousel
  },
  data() {
    return {
      loader: false,
      data: [],
      message: {},
      chatGptList: [],
      email: "",
      sendAsEmail: false,
      gptData: [],
      total: 0,
      perPage: 1,
      messageAI: [],
      messageAIPlain: '',
      loadTimes: 0,
      pageTimes: 0,
    };
  },
  watch: {
    uses: {
      handler(value) {
        this.message = value;
        // this.reportLoading = value
      },
      deep: true,
      immediate: true,
    },
  },
  methods: {
    saveRes(){
      this.dowloadReport2(true)
    },
    regenerateRes(){
      this.generateRes();
    },
    gptValue(data) {
      this.gptData = [...this.gptData, data];
      // console.log(this.gptData);
    },
    async getDataUri(url) {
        const proxyUrl = 'https://cors-anywhere.herokuapp.com/';
        const targetUrl = proxyUrl+url;

        return new Promise((resolve, reject) => {
            var image = new Image();
            image.setAttribute('crossOrigin', 'anonymous'); // Getting images from an external domain

            image.onload = function () {
                try {
                    var canvas = document.createElement('canvas');
                    canvas.width = this.naturalWidth;
                    canvas.height = this.naturalHeight;

                    var ctx = canvas.getContext('2d');
                    ctx.fillStyle = '#fff'; // Set white fill style
                    ctx.fillRect(0, 0, canvas.width, canvas.height);

                    ctx.drawImage(this, 0, 0);

                    resolve(canvas.toDataURL('image/jpeg'));
                } catch (error) {
                    reject(error);
                }
            };

            image.onerror = function () {
                reject(new Error('Failed to load the image at ' + url));
            };

            image.src = targetUrl;
        });
    },
    async dowloadReport2(arg) {

      this.pageTimes = 0;
      const doc = new jsPDF("p", "mm", "a4");

      // Function to check if content exceeds the remaining space on the page
      function checkPageOverflow(yPosition, contentHeight) {
        const pageHeight = doc.internal.pageSize.height;
        return yPosition + contentHeight > pageHeight;
      }

    // Function to add a new page
      function addNewPage() {
        doc.addPage();
      }

      doc.setFontSize(18);
      doc.setTextColor(87, 181, 163);
      var img2 = "spendid-logo.png";
      doc.addImage(img2, "PNG", 8, 8, 35, 35);
      // var img3 = "spendid-logo.png";
      // doc.addImage(img3, "PNG", 68, 12, 0, 0);
      doc.text(140, 10, `${moment(new Date()).format('MM/DD/YYYY, h:mm:ss a')}`);

      // doc.addImage(img2, "PNG", 8, 8, 20, 20);
      // doc.addImage(img2, "PNG", 10, 10, 45, 25);
      pos += 20;
      doc.setFontSize(18);
      doc.setTextColor(68, 68, 68);
      doc.setFont(undefined, "bold");
      doc.setFontSize(12);

      var pos = 40;
      var n_pos = 15;
      const line_height = 5;

    // Loop through the array and add content to the PDF
    for (let index = 0; index < this.messageAI.length; index++) {
      var item = this.messageAI[index];
      // Add title in bold
      if (checkPageOverflow(pos, 50)) {
          addNewPage();
          pos = 20; // Reset Y position on the new page
      }
      doc.setFont(undefined, "bold");
      doc.setFontSize(16);
      doc.text(10, pos, `${item.title}`);

      // Reset font style
      doc.setFont(undefined, "normal");
      
      var logo = await this.getDataUri(item.imageUrl);

      const lines = doc.splitTextToSize(item.description, (doc.internal.pageSize.width/1.4) - 10);
      doc.addImage(logo, "PNG", 120, pos, 60, 60);

      doc.setFontSize(12);
      // Add each line to the PDF
      lines.forEach((line, lineIndex) => {
        pos  = pos + 8
        if (checkPageOverflow(pos, 50)) {
            addNewPage();
            pos = 20; // Reset Y position on the new page
          }
        doc.text(10, pos, line);
      });

      // Add results with bullets
      item.list.forEach((result, resultIndex) => {
        // Check if adding the next content exceeds the remaining space on the page
        if (checkPageOverflow(pos, 50)) {
          addNewPage();
          pos = 20; // Reset Y position on the new page
        }

        // Split the result using splitTextToSize
        const lines = doc.splitTextToSize(result, (doc.internal.pageSize.width/2) - 10);

        // Add each line to the PDF
        lines.forEach((line, lineIndex) => {
          pos  = pos + 8
          if (checkPageOverflow(pos, 50)) {
            addNewPage();
            pos = 20; // Reset Y position on the new page
          }
          doc.text(10, pos, line);
        });

        // Update the Y position based on the number of lines
        // pos += lines.length * 10;
      });

      // Add spacing between sections
      pos += 10;
    };
      // doc.setFontWeight("bold");
      // if(lines.length > 50){
      //   doc.text(lines.slice(0, 50), n_pos, pos);
      //   doc.addPage(2)
      //   doc.text(lines.filter((item, i)=> i>=50 ), n_pos, 20);
      // } else {
      //   doc.text(lines, n_pos, pos);
      // }

      if (arg) {
        doc.save("SPENDiD Report.pdf");
      } else {
        var blob = doc.output("blob");
        var formData = new FormData();
        formData.append("file", blob);
        formData.append("email", this.email);
        formData.append("origin", "GradBudget");
        const result = await this.$http.post(
          "https://business.spendid.io/api/send-report-pdf",
          formData
        );
        this.email = "";
        this.sendAsEmail = false;
        this.$toasted.success("Report sent by Email").goAway(3000);
      }
    },
    async dowloadReport(arg) {

      this.pageTimes = 0;
      const doc = new jsPDF("p", "mm", "a4");

      // Function to check if content exceeds the remaining space on the page
      function checkPageOverflow(yPosition, contentHeight) {
        const pageHeight = doc.internal.pageSize.height;
        return yPosition + contentHeight > pageHeight;
      }

    // Function to add a new page
      function addNewPage() {
        doc.addPage();
      }
  
      doc.setFontSize(18);
      doc.setTextColor(87, 181, 163);
      var img2 = "spendid-logo.png";
      doc.addImage(img2, "PNG", 8, 8, 35, 35);
      // var img3 = "spendid-logo.png";
      // doc.addImage(img3, "PNG", 68, 12, 0, 0);
      // doc.addImage(img2, "PNG", 8, 8, 20, 20);
      // doc.addImage(img2, "PNG", 152, 10, 45, 25);
      pos += 20;
      doc.setFontSize(18);
      doc.setTextColor(68, 68, 68);
      doc.setFont(undefined, "bold");
      doc.text(this.message.title, 105, 35, null, null, "center");
      doc.setFontSize(12);

      var pos = 50;
      var n_pos = 15;
      const line_height = 5;

    // Loop through the array and add content to the PDF
    this.messageAI.forEach((item, index) => {
      // Add title in bold
      if (checkPageOverflow(pos, 50)) {
          addNewPage();
          pos = 20; // Reset Y position on the new page
      }
      doc.setFont(undefined, "bold");
      doc.setFontSize(16);
      doc.text(30, pos, `${item.title}`);

      // Reset font style
      doc.setFont(undefined, "normal");

      // Add results with bullets
      doc.setFontSize(12);
      item.results.forEach((result, resultIndex) => {
        // Check if adding the next content exceeds the remaining space on the page
        if (checkPageOverflow(pos, 50)) {
          addNewPage();
          pos = 20; // Reset Y position on the new page
        }

        // Split the result using splitTextToSize
        const lines = doc.splitTextToSize(result, doc.internal.pageSize.width - 60);

        // Add each line to the PDF
        lines.forEach((line, lineIndex) => {
          doc.text(30, pos + (lineIndex+1) * 10, line);
        });

        // Update the Y position based on the number of lines
        pos += lines.length * 10;
      });

      // Add spacing between sections
      pos += item.results.length * 10 + 10;
    });
      // doc.setFontWeight("bold");
      // if(lines.length > 50){
      //   doc.text(lines.slice(0, 50), n_pos, pos);
      //   doc.addPage(2)
      //   doc.text(lines.filter((item, i)=> i>=50 ), n_pos, 20);
      // } else {
      //   doc.text(lines, n_pos, pos);
      // }

      if (arg) {
        doc.save("SPENDiD Report.pdf");
      } else {
        var blob = doc.output("blob");
        var formData = new FormData();
        formData.append("file", blob);
        formData.append("email", this.email);
        formData.append("origin", "GradBudget");
        const result = await this.$http.post(
          "https://business.spendid.io/api/send-report-pdf",
          formData
        );
        this.email = "";
        this.sendAsEmail = false;
        this.$toasted.success("Report sent by Email").goAway(3000);
      }
    },
    nextPage() {
      this.getChatGptResponse();
    },
    async generateRes() {
      this.loader = true;

      const promptRes = await this.$http.get('https://admin.spendid.io/api/prompt', {});

      const promptData = {
        ZIP: this.message.zip,
        AGE: this.message.age,
        EXPENSE_CATEGORY: this.message.title,
        MEMBER: this.message.size,
      };


      let text = "";
      if(!this.message.largePrompt){
        if (this.message.title == "Income") {
          text = promptRes.data.data.income;
        } else {
          text = promptRes.data.data.expense;
        }

        text = text
        .replace(/\[ZIP\]/g, promptData.ZIP)
        .replace(/\[AGE\]/g, promptData.AGE)
        .replace(/\[EXPENSE_CATEGORY\]/g, promptData.EXPENSE_CATEGORY)
        .replace(/\[MEMBER\]/g, promptData.MEMBER);

        text = `${text} Response Should be in array of object format like
        [
          {
            title: <title_here>,
            results: [<bullet_points_in_array>]
          }
        ]
        and return as JSON stringify data`

      } else {
        text = this.message.title
      }


      // console.log(this.message);
      this.loadTimes = this.loadTimes + 1;
      this.loader = true;
      const formData = new FormData();
      formData.append("task", "plain");
      formData.append(
        "text",
        text
      );
      // const result = await this.$http.post(
      //   "https://editor.creativebuffer.com/get_response_2/",
      //   formData
      // );
      let response1, response2, urlMap;
        this.error = false;

        try {
          await this.$http.post(
            "https://editor.creativebuffer.com/get_response_2/",
            formData
          ).then((result)=>{
            response1 = JSON.parse(result.data.data);
          }).catch(()=>{
            this.loader = false;
            this.error = true;
          });
           try {
             const formData1 = new FormData();
             console.log("result.data.data",JSON.stringify(response1))
             formData1.append("response_data", JSON.stringify(response1));
             const result1 = await this.$http.post(
               "https://editor.creativebuffer.com/threadimage_gen/",
               formData1
             );

             response2 = result1.data.image_urls;
             urlMap = response2.reduce((map, obj) => {
               const title = Object.keys(obj)[0];
               map[title] = obj[title];
               return map;
             }, {});

           } catch (error) {
             // eslint-disable-next-line no-console
             console.error("Error in second API call:", error);
           }
        } catch (error) {
          // eslint-disable-next-line no-console
          console.error("Error in first API call:", error);
          this.loader = false;
          if(!response1){
            this.error = true;
          }
          return;
        }

        // Merge the responses if second API call succeeded
        let mergedResponse = response1;
        if (urlMap) {
          mergedResponse = response1.map(item => {
            const imageUrl = urlMap[item.title];
            return { ...item, imageUrl };
          });
        }
        if (!this.message.largePrompt) {
        if (this.loadTimes > 1) {
          this.messageAI = [...this.messageAI, ...mergedResponse];
        } else {
          this.messageAI = [...this.messageAI, ...mergedResponse];
        }
      } else {
        this.messageAI = mergedResponse;
      }

      this.loader = false;
    },
    async getChatGptResponse() {
      var formData = new FormData();
      formData.append("type", `${this.message.type} Expenses`);
      formData.append("category", this.message.title);
      // formData.append('task', 'plain  ');
      // formData.append('text',  `This request is on the topic of how to save money on ${this.message}. Write a 50-word summary paragraph of advice in a friendly but confident tone. If available, include in the summary numeric facts about how much a User can likely save in this expense category if they really try and focus on it. Below the summary show the top 5 actionable tips with number for the user in order to save money in this expense category. Show these tips in bullet point form with each bullet text being approximately 12-15 words long. At the top of your response, show the following full sentence text in larger bold font: Here are some ways to lower your expenses for  ${this.message} Skip a line after the title of the response.`);
      try {
        const result = await this.$http.post(
          `https://biz.spendid.io/api/get-advice-data?per_page=3&page=${this.perPage}`,
          formData
        );
        // console.log(result.data);
        this.loader = false;
        this.perPage = this.perPage + 1;
        this.total = result.data.results.total;
        const chatGptList = [...this.chatGptList, ...result.data.results.data];

        //     const chatGptList = result.data.data.split('\n\n').map(item => {
        //       if(item){
        //           if(item.includes('\n')){
        //               return item;
        //           }
        //           return item;
        //       }
        //       return '';
        //     })
        this.chatGptList = chatGptList;
      } catch (error) {
        console.log(error);
      }
    },
  },
  beforeMount() {
    this.loader = true;

    this.gptData = [];
    // this.getChatGptResponse();
  },
  computed: {
    processedString() {
      return this.chatGptList.replace(/[^\w\s]+$/, "***");
    },
  },
  async mounted() {
    this.generateRes();
  },
};
</script>